import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './infrastructure/prototype-extentions';
import App from './app/components/app';
import {BrowserRouter} from 'react-router-dom';
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('bolao-root'));
root.render(
  <BrowserRouter>
    <HelmetProvider>
      <App/>
    </HelmetProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
